import { useTranslation } from "react-i18next";
import { NeuPicker } from "../../components/neu/NeuPicker";
import { DateInput } from "../../components/neu/DateInput";

// فلاتر التقارير الإدارية: نفس القوائم البارزة والاختيار الإجباري المتبعة في الرواتب.
export const ReportFilters = ({ filters, setFilters, branches, employees }) => {
  const { t } = useTranslation();
  const set = (key) => (e) => setFilters({ ...filters, [key]: e.target.value });

  return (
    <div className="grid gap-3 sm:grid-cols-2" data-testid="report-filters">
      <DateInput label={t("dashboard.from")} testId="filter-from" value={filters.from_date}
        onChange={(v) => setFilters({ ...filters, from_date: v })} />
      <DateInput label={t("dashboard.to")} testId="filter-to" value={filters.to_date}
        onChange={(v) => setFilters({ ...filters, to_date: v })} />
      <NeuPicker className="sm:col-span-2" testId="filter-branch"
                 value={filters.branch_id} onChange={set("branch_id")}>
        <option value="">{t("payrollFilters.selectBranch")}</option>
        <option value="all">{t("dashboard.allBranches")}</option>
        {branches.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
      </NeuPicker>
      <NeuPicker className="sm:col-span-2" testId="filter-employee"
                 value={filters.user_id} onChange={set("user_id")}>
        <option value="">{t("payrollFilters.selectEmployee")}</option>
        <option value="all">{t("dashboard.employees")}</option>
        {employees.map((e) => <option key={e.id} value={e.id}>{e.name}</option>)}
      </NeuPicker>
    </div>
  );
};
